import React, { useState, useEffect } from 'react';
import { Form, Modal, Row } from 'react-bootstrap';
import { t } from 'i18next';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { getTemplates } from '../../../../redux/template';
import useDebounce from '../../../../utils/useDebounceHook';
import { optionsStyle } from '../composables';

const SearchTemplateModal = ({
	show,
	close,
	handleSelectTemplate,
	type,
	options,
	pId,
	isFromSettings = false,
}) => {
	const dispatch = useDispatch();
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearch = useDebounce(searchTerm, 500);

	const handleInputChange = (inputValue) => {
		setSearchTerm(inputValue);
	};

	useEffect(() => {
		if (!isFromSettings) {
			dispatch(
				getTemplates({ type: type.toLowerCase(), search: debouncedSearch, per_page: 10, pId: pId })
			);
		}
	}, [debouncedSearch, dispatch]);

	const handleClose = () => {
		close();
	};

	return (
		<Modal show={show} onHide={handleClose} backdrop="static" centered>
			<Modal.Header closeButton>
				<Modal.Title>
					{t('GENERAL.SEARCH')} {type} Template{' '}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="mb-3">
					<Form.Group>
						<Form.Label>Name </Form.Label>
						<Select
							onInputChange={handleInputChange}
							menuPortalTarget={document.body}
							styles={optionsStyle}
							options={options.map((option) => ({
								label: option.name,
								value: option.id,
							}))}
							value={
								options.find((option) => option.name === searchTerm) || null
							}
							onChange={handleSelectTemplate}
							className="basic-single w-100"
							classNamePrefix="select"
						/>
					</Form.Group>
				</Row>
			</Modal.Body>
		</Modal>
	);
};

export default SearchTemplateModal;
